import { render, staticRenderFns } from "./editIncomeType.vue?vue&type=template&id=d4254bae&scoped=true&"
import script from "./editIncomeType.vue?vue&type=script&lang=js&"
export * from "./editIncomeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4254bae",
  null
  
)

export default component.exports